'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$StoreGroupRequest(id, code, name, users, roles) {
  this.a0t = null;
  this.a0s = null;
  this.a0u = null;
  this.a0w = null;
  this.a0v = null;
  this.a0t = id;
  this.a0s = code;
  this.a0u = name;
  this.a0w = users;
  this.a0v = roles;
}
export { $c_Lpresto_types$proto$StoreGroupRequest as $c_Lpresto_types$proto$StoreGroupRequest };
$p = $c_Lpresto_types$proto$StoreGroupRequest.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$StoreGroupRequest;
/** @constructor */
function $h_Lpresto_types$proto$StoreGroupRequest() {
}
export { $h_Lpresto_types$proto$StoreGroupRequest as $h_Lpresto_types$proto$StoreGroupRequest };
$h_Lpresto_types$proto$StoreGroupRequest.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$proto$StoreGroupRequest)) {
    var x = this.a0t;
    var x$2 = x$0.a0t;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      var x$3 = this.a0s;
      var x$4 = x$0.a0s;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_2 = false;
    }
    if (($x_2 && (this.a0u === x$0.a0u))) {
      var x$5 = this.a0w;
      var x$6 = x$0.a0w;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.a0v;
      var x$8 = x$0.a0v;
      return ((x$7 === null) ? (x$8 === null) : x$7.i(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 5;
});
$p.s = (function() {
  return "StoreGroupRequest";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.a0t;
      break;
    }
    case 1: {
      return this.a0s;
      break;
    }
    case 2: {
      return this.a0u;
      break;
    }
    case 3: {
      return this.a0w;
      break;
    }
    case 4: {
      return this.a0v;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$proto$StoreGroupRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lX)));
}
export { $isArrayOf_Lpresto_types$proto$StoreGroupRequest as $isArrayOf_Lpresto_types$proto$StoreGroupRequest };
var $d_Lpresto_types$proto$StoreGroupRequest = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$StoreGroupRequest, "presto.types$proto$StoreGroupRequest", ({
  lX: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$StoreGroupRequest as $d_Lpresto_types$proto$StoreGroupRequest };
//# sourceMappingURL=presto.types$proto$-Store-Group-Request.js.map
